// BSL-RDV §5 — Randevu turları. Ekran başına en çok 3 balon, metin ≤ 140 karakter.
// Bir `data-tur` elemanı silinir/taşınırsa bu dosya aynı commit'te düzeltilir (çatı §12).
// sekme: Randevu Ayarları'nda turun sekmesi (bsl.sekmeIstegi). sonraki: son balonda ikinci tur bağlantısı.
export default {
  randevuSaat: {
    yol: "/randevu/ayarlar",
    sekme: "4",
    sonraki: { anahtar: "randevuGenel", etiket: "Genel Ayarlar'ı da tanıt" },
    adimlar: [
      { hedef: '[data-tur="saat-kimin"]', metin: "Şube geneli ya da tek personel için saat girin. Personelin saati şubeninkinin önüne geçer.", kavram: "saatOnceligi" },
      { hedef: '[data-tur="saat-tablo"]', metin: "Her gün için açık/kapalı, başlangıç, bitiş ve mola. Bir günü kopyalayıp diğerlerine uygulayabilirsiniz." },
      { hedef: '[data-tur="saat-kaydet"]', metin: "Kaydedin. Randevu süresi ve tampon Genel Ayarlar sekmesindedir." },
    ],
  },
  randevuGenel: {
    yol: "/randevu/ayarlar",
    sekme: "0",
    adimlar: [
      { hedef: '[data-tur="ayar-sure"]', metin: "Takvimin saat dilimi; süresi girilmemiş randevular bu süreyi alır.", kavram: "randevuSuresi" },
      { hedef: '[data-tur="ayar-tampon"]', metin: "İki randevu arasında bırakılacak hazırlık süresi.", kavram: "tampon" },
      { hedef: '[data-tur="ayar-eszamanli"]', metin: "Aynı saate kaç randevu alınabileceği; tek koltuk ya da oda için 1.", kavram: "esZamanli" },
    ],
  },
  randevuTip: {
    yol: "/randevu/ayarlar",
    sekme: "1",
    adimlar: [
      { hedef: '[data-tur="tip-yeni"]', metin: "Verdiğiniz hizmetleri süreleriyle ekleyin; müşteri online randevuda bunları seçer." },
      { hedef: '[data-tur="tip-genel"]', metin: "«Genel» her şubede hazır gelir, süresini Genel Ayarlar'dan alır, silinmez.", kavram: "genelTip" },
    ],
  },
  randevuTakvim: {
    yol: "/randevu/dashboard",
    adimlar: [
      { hedef: '[data-tur="randevu-yeni"]', metin: "Yeni randevuyu buradan açın; müşteri listede yoksa formdan ekleyebilirsiniz." },
      { hedef: '[data-tur="randevu-takvim"]', metin: "Takvim seçili şubeyi gösterir. Randevuya tıklayıp düzenleyin ya da iptal edin." },
      { hedef: '[data-tur="randevu-paylas"]', metin: "Online randevu bağlantınızı paylaşın; müşteri boş saati kendisi seçer." },
      // RH-2: blok randevu formunda, müşterinin hakkı varsa görünür; yoksa balon atlanır
      { hedef: '[data-tur="randevu-hak"]', metin: "Müşterinin satın aldığı hizmet varsa formda listelenir; seçin, seanslar paketten düşer.", kavram: "hizmetHakki" },
    ],
  },
  randevuPaylas: {
    yol: "/randevu/dashboard",
    pencere: true,
    adimlar: [
      { hedef: '[data-tur="paylas-kopyala"]', metin: "Bağlantıyı kopyalayın; her şubenin kendi bağlantısı var." },
      { hedef: '[data-tur="paylas-qr"]', metin: "QR kodunu yazdırıp girişe asabilir, gömme koduyla sitenize ekleyebilirsiniz." },
      { hedef: '[data-tur="paylas-dene"]', metin: "Formu açıp kendinize deneme randevusu alın; sonra takvimden iptal edin." },
    ],
  },
};
